"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lerpNumber = void 0;
function lerpNumber(start, end, percent, clamp = false) {
    const range = end - start;
    if (!clamp) {
        return percent * range + start;
    }
    let clampedP = percent;
    if (clampedP < 0) {
        clampedP = 0;
    }
    else if (clampedP > 1) {
        clampedP = 1;
    }
    return clampedP * range + start;
}
exports.lerpNumber = lerpNumber;
